export const IMPACT = {
  heading: 'Empowering the Next Generation',
  mission: `Technology has the power to transform lives — but only if everyone has access to it. At OrionDev, we are passionate about bridging the digital divide by equipping rural and underprivileged youth with the skills, mentorship, and resources they need to thrive in the tech industry.`,
  stats: [
    { label: 'Youth Trained', value: 120, suffix: '+' },
    { label: 'Communities Reached', value: 8, suffix: '' },
    { label: 'Programs Running', value: 3, suffix: '' },
    { label: 'Success Rate', value: 85, suffix: '%' },
  ],
  programs: [
    {
      title: 'Code Camp',
      description: 'Intensive coding bootcamps for rural youth, covering web development, mobile apps, and software fundamentals.',
    },
    {
      title: 'Tech Mentorship',
      description: 'One-on-one mentorship pairing experienced developers with aspiring young technologists in underserved areas.',
    },
    {
      title: 'Connectivity Access',
      description: 'Bringing the internet to communities the networks never reached — we deploy Starlink satellite connections at rural schools and community hubs, so learners and local businesses can get online for the first time.',
    },
  ],
  cta: {
    heading: 'Partner With Us',
    description: 'Whether you want to sponsor a student, host a workshop, or contribute resources — every bit helps shape the future of a young technologist.',
  },
}
